/**
 * RB-UX Help & glossary score tables (handoff 30 Item 2).
 * Source of truth: SiteConfigBuilder/src/ui/dashboard.js
 *   EDX_BANDS_FULL, BRITTLENESS_BANDS_FULL, howToReadScores.
 * Static reference content; only ◄ row marking is per-property.
 */

export const EDX_BANDS_FULL = [
  [9, '100–120', '92–100%', 'Ecosystem at fullest expression. Strengthens under disturbance.',
    ['95–100%', 'Infiltration efficient; minimal runoff'],
    ['90–100%', 'Soil surface stable; negligible erosion'],
    ['95–100%', 'High live canopy; strong capture/conversion'],
    ['85–100%', 'Diverse; desirable FGs vigorous; rares present']],
  [8, '60–100', '77–92%', 'All processes highly active. Strong biological diversity and vitality.',
    ['90–95%', 'Good infiltration; rare rills'],
    ['80–90%', 'Stable; no active pedestals'],
    ['85–95%', 'High photosynthetic mass'],
    ['75–85%', 'Good structure; low undesirables']],
  [7, '40–60', '69–77%', 'All core processes functioning well. Minor vulnerabilities only.',
    ['85–90%', 'Mostly effective; occasional limits'],
    ['70–80%', 'Mostly stable'],
    ['75–85%', 'Robust growth; short stress dips'],
    ['65–75%', 'FGs healthy; rares occasional']],
  [6, '20–40', '62–69%', 'Measurable improvement underway. Trajectory clearly positive.',
    ['80–85%', 'Some runoff events'],
    ['60–70%', 'Minor instability showing'],
    ['60–75%', 'Seasonal dips evident'],
    ['55–65%', 'Some FG weakness/patchiness']],
  [5, '0–20', '54–62%', 'Some processes functioning, others compromised. Trend unstable.',
    ['70–80%', 'Runoff frequent storms'],
    ['50–60%', 'Localised erosion/capping'],
    ['40–60%', 'Uneven canopy'],
    ['45–55%', 'Undesirables creeping']],
  [4, '−20–0', '46–54%', 'Multiple processes impaired. System under significant strain.',
    ['60–70%', 'Poor soak; frequent sheet flow'],
    ['40–50%', 'Pedestals appear'],
    ['30–40%', 'Canopy thin; litter patchy'],
    ['35–45%', 'Key FGs weakening']],
  [3, '−40–−20', '38–46%', 'Most processes failing. Structural damage evident. Urgent action needed.',
    ['50–60%', 'Regular runoff; rills'],
    ['30–40%', 'Erosion signals common'],
    ['20–30%', 'Low biomass; slow recovery'],
    ['25–35%', 'Undesirables common; rares rare']],
  [2, '−60–−40', '31–38%', 'Severe dysfunction across systems. Biological capital critically low.',
    ['40–50%', 'Little infiltration'],
    ['20–30%', 'Active erosion; capping widespread'],
    ['10–20%', 'Low photosynthesis'],
    ['15–25%', 'FGs failing; low diversity']],
  [1, '−140–−60', '0–31%', 'System failure. Bare soil dominant, minimal vegetation or function.',
    ['0–40%', 'Flashy water loss'],
    ['0–20%', 'Severe erosion'],
    ['0–10%', 'Bare/standing dead dominate'],
    ['0–15%', 'Collapse towards few stress-tolerant spp.']],
];

/** [lo, hi, label, definition, fieldValidation, managementImplication] */
export const BRITTLENESS_BANDS_FULL = [
  [1, 2, 'Very Non-Brittle',
    'Even rainfall, year-round growth, humid decomposition.',
    'Dung and litter disappear in weeks; minimal bare soil.',
    'Main risk is overgrazing or compaction. Focus on rest, diversity, and avoiding disturbance.'],
  [2, 4, 'Non-Brittle',
    'Rainfall well spread, short dry season.',
    'Dung and litter break down within one to two months.',
    'Root-cause issues tend to be nutrient leaks and compaction, not water stress.'],
  [4, 6, 'Semi-Brittle',
    'Rainfall patchy, longer dry spells.',
    'Dung and litter persist 2 to 6 months; some bare soil.',
    'Both overgrazing and over-rest are possible; effective rainfall begins to matter.'],
  [6, 8, 'Brittle',
    'Long dry season; rainfall arrives in bursts.',
    'Dung and litter persist more than 6 months; large patches of bare soil.',
    'Water and mineral cycles fragile; animal impact required to restore cover and litter.'],
  [8, 10, 'Very Brittle',
    'Rainfall erratic; ecosystem inactive for long periods.',
    'Dung and litter persist more than a year; moribund material accumulates; biological crusts and persistent bare ground are common at the upper end.',
    'Over-rest is the major problem; trampling and littering essential to kick-start processes. At the upper end, water design (keyline, catchments, ponds) becomes essential.'],
];

/** Index into BRITTLENESS_BANDS_FULL for a Savory score (handoff 30 / RB-UX). */
export function brittlenessBandIndex(score) {
  const sc = Number(score);
  if (Number.isNaN(sc)) return -1;
  if (sc < 2) return 0;
  if (sc < 4) return 1;
  if (sc < 6) return 2;
  if (sc < 8) return 3;
  return 4;
}
